export const FIND_MAIL_TEMPLATE_SUCCESS = 'FIND_MAIL_TEMPLATE_SUCCESS';

export const findMailTemplateSuccess = mailTemplate => ({
    type: FIND_MAIL_TEMPLATE_SUCCESS,
    payload: { mailTemplate },
});
